import './ShinyText.css';

/**
 * ReactBits — ShinyText.
 *
 * Sweeps a soft highlight across the text on a continuous loop. Great for
 * marketing headlines without being distracting.
 *
 * Props:
 *   text     — string content
 *   disabled — pause the animation
 *   speed    — seconds per sweep (default 5s)
 *   className — extra Tailwind / CSS classes
 */
const ShinyText = ({ text, disabled = false, speed = 5, className = '' }) => {
  const animationDuration = `${speed}s`;
  return (
    <span
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`.trim()}
      style={{ animationDuration }}
    >
      {text}
    </span>
  );
};

export default ShinyText;
